export default {
  data: () => {
    return {
      sending: false,
      error: false
    }
  }
}
